module.exports = __webpack_public_path__ + "static/img/BU02-3.0e5f135.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02-3.jpg
// module id = Py5L
// module chunks = 1